<template>
  <transition name="mobile-slide" appear>
    <div :class="$style.wrapper" v-if="!opened">
      <div :class="$style.top">
        <slot />
        {{site.title}}
      </div>
      <svg width="219" height="165" viewBox="0 0 219 165" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="183" height="30" rx="15" fill="#DCDCE7"/>
        <rect y="45" width="119" height="30" rx="15" fill="#DCDCE7"/>
        <rect x="134" y="45" width="85" height="30" rx="15" fill="#DCDCE7"/>
        <rect y="90" width="71" height="30" rx="15" fill="#DCDCE7"/>
        <rect x="83" y="90" width="136" height="30" rx="15" fill="#DCDCE7"/>
        <rect y="135" width="119" height="30" rx="15" fill="#DCDCE7"/>
        <rect x="134" y="135" width="85" height="30" rx="15" fill="#DCDCE7"/>
      </svg>
      <div :class="$style.bottom">
        <v-btn large color="green" @click="handleClick">
          <template v-if="site.ready">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 7L6.5 12.5L18 1" stroke="white" stroke-width="2"/>
            </svg>
          </template>
          <template v-else>
            ВОЙТИ
          </template>
        </v-btn>
        <svg width="53" height="30" viewBox="0 0 53 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="53" height="30" rx="15" fill="#DCDCE7"/>
        </svg>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'site',
  props: {
    site: Object,
    index: Number,
  },
  data: () => ({
    opened: false,
  }),
  methods: {
    handleClick() {
      if (this.site.ready) return

      this.$emit('open', this.index)
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  width: 24.6rem;
  height: 47.1rem;
  background: #F0F0F5;
  border-radius: 1.5rem;
  padding: 2rem;
  position: relative;

  & > svg {
    width: 100%;
    height: auto;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }

  //& + & {
  //  margin-left: 2rem;
  //}
}

.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 1.4rem;

  img {
    display: block;
    width: 5rem;
    height: auto;
    margin-bottom: 0.5rem;
  }
}

.bottom {
  width: 100%;

  & > button {
    display: block;
    margin: 0 auto;

    svg {
      position: static;
      width: 1.9rem;
      height: auto;
    }
  }

  svg {
    position: absolute;
    bottom: 2rem;
    right: 2rem;
  }
}
</style>
